module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_gaku-2d6f83b82b2c4d9fec4cab54a6f61ebe.png";